import type { operations } from '@/types/schemas/api.JS-10706';
import { POST } from '../../_http';
type controller = operations['BrokerCreateApplicationDraftController_post'];

export type BrokerCreateApplicationDraftBody = controller['requestBody']['content']['application/json'];
export type BrokerCreateApplicationDraftResponse = controller['responses']['200']['content']['application/json'];

export const brokerCreateApplicationDraft = POST('/brokers/applications-draft/create-application-draft')<
  BrokerCreateApplicationDraftBody,
  BrokerCreateApplicationDraftResponse
>;
